import { cn } from "@nexxt/ui";
import type { ReactNode } from "react";

// A few lines in the tone of what they say (design-system.md §2.2), the same box in every screen.

type NoteTone = "info" | "warning" | "danger";

const toneClass: Record<NoteTone, string> = {
  info: "bg-info-bg text-info-fg",
  warning: "bg-warning-bg text-warning-fg",
  danger: "bg-danger-bg text-danger-fg",
};

/**
 * `info` while the system works, `warning` for a wait or a doubt that needs someone, `danger` for what failed or stops
 * an action: only this one is announced (`role="alert"`).
 */
export function Note({ tone, className, children }: { tone: NoteTone; className?: string; children: ReactNode }) {
  return (
    <div
      role={tone === "danger" ? "alert" : undefined}
      className={cn("rounded-md px-3 py-2 text-sm", toneClass[tone], className)}
    >
      {children}
    </div>
  );
}
